import Select from "components/fields/Select";
import { FiSearch } from "react-icons/fi";
import "mapbox-gl/dist/mapbox-gl.css";
import mapboxgl from "mapbox-gl/dist/mapbox-gl";
import { useEffect, useRef, useState } from "react";
import ReactDOMServer from "react-dom/server";
import StatusLabel from "components/label/StatusLabel";
import { useDarkmode } from "hooks/useTheme";
import { useDisclosure } from "@chakra-ui/hooks";
import {
  Drawer,
  DrawerCloseButton,
  DrawerContent,
  ModalOverlay,
} from "@chakra-ui/modal";
import UserDetails from "../people/user-details";
import EditUser from "../people/edit-user";
import AtriumApi from "api";
import Avatar from "components/avatar";
import { useDebounce } from "use-debounce";
import Loader from "components/loader/Loader";

const MemberLocation = (props) => {
  const { darkmode } = useDarkmode();
  const [readonlyForm, setReadonlyForm] = useState(true);
  const [users, setUsers] = useState([]);
  const [user, setUser] = useState({});
  const [campuses, setCampuses] = useState([]);
  const [church, setChurch] = useState();
  const [map, setMap] = useState();
  const [mapMode, setMapMode] = useState("normal");
  const [campusFilter, setCampusFilter] = useState("all");
  const [campusId, setCampusId] = useState([]);
  const [queryOptions, setQueryOptions] = useState({});
  const [loading, setLoading] = useState(false);
  const { isOpen, onOpen, onClose } = useDisclosure({
    onClose: () => {
      setReadonlyForm(true);
    },
  });

  const [debouncedSearchQuery] = useDebounce(queryOptions?.search, 600);
  const campusMarkersRef = useRef([]);

  const secondsToString = (seconds) => {
    const numhours = Math.floor(seconds / 3600);
    const numminutes = Math.floor((seconds % 3600) / 60);
    const hUnit = numhours > 0 && (numhours > 1 ? " hours " : " hour ");
    return (hUnit ? numhours + hUnit : "") + numminutes + " minutes ";
  };

  // Get All campuses
  useEffect(() => {
    const fetchCampuses = async () => {
      setLoading(true);
      try {
        const response = await AtriumApi.get("/v2/campuses/allCampuses");
        if (response) {
          setLoading(false);
          setCampusId(response?.data?.data?.campuses?.data);
        }
      } catch (error) {
        setLoading(false);
        console.log("error while fetching all campuses", error);
      }
    };
    fetchCampuses();
  }, []);

  useEffect(() => {
    setLoading(true);
    AtriumApi.get(`/v1/member-location-data`, {
      params: {
        search: debouncedSearchQuery,
        driveTimeRange: queryOptions?.driveTimeRange,
        campusId: campusFilter,
      },
    })
      .then((resp) => {
        setUsers(resp?.data?.data?.members);
        setCampuses(resp?.data?.data?.campuses);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => setLoading(false));
  }, [queryOptions?.driveTimeRange, debouncedSearchQuery, campusFilter]);

  useEffect(() => {
    AtriumApi.get("/v1/church")
      .then((resp) => {
        setChurch({
          ...resp.data.church,
          lat: resp?.data?.church?.location?.coordinates[1],
          lng: resp?.data?.church?.location?.coordinates[0],
        });
      })
      .catch((err) => {});
  }, []);

  useEffect(() => {
    mapboxgl.accessToken =
      "pk.eyJ1IjoicnlhbmZhIiwiYSI6ImNtNXY1MndkNjAzeDgybHEwMHA0ZTl6N3AifQ.QHHFfo9es-0zSqfUbr3tYw";
    const mapOptions = {
      container: "map",
      style: darkmode
        ? "mapbox://styles/mapbox/dark-v11"
        : "mapbox://styles/mapbox/light-v11",
      zoom: 10,
      minZoom: 5,
      projection: "equirectangular", // "albers" | "equalEarth" | "equirectangular" | "lambertConformalConic" | "mercator" | "naturalEarth" | "winkelTripel" | "globe";
    };
    const newMap = new mapboxgl.Map(mapOptions);

    newMap.on("style.load", () => {
      // newMap.setPaintProperty('projection', 'fill-color', '#000');
      // newMap.setPaintProperty('background', 'line-color', '#000');
      // newMap.setPaintProperty('water', 'fill-color', '#a0c4ff');
      // newMap.setPaintProperty('land', 'line-color', '#000', 'fill-color', '#000');
      // newMap.setPaintProperty('land', 'line-color', '#ff4500', 'fill-color', '#000');
      // newMap.setPaintProperty('road', 'line-color', '#ff4500');
      // newMap.setPaintProperty('road-major', 'line-color', '#ff4500');
      // newMap.setPaintProperty('road-minor', 'line-color', '#ff4500');
    });

    newMap.on("load", () => {
      setMap(newMap);
    });

    return () => {
      newMap.off("load");
      newMap.remove();
    };
  }, [darkmode]);

  useEffect(() => {
    if (!map || !users) return;

    // Sample GeoJSON data with points
    const geojson = {
      type: "FeatureCollection",
      features: users
        .filter(
          (user) =>
            user?.location?.coordinates[1] && user?.location?.coordinates[0]
        )
        .map((user) => ({
          type: "Feature",
          properties: user,
          geometry: {
            type: "Point",
            coordinates: [
              user?.location?.coordinates[0],
              user?.location?.coordinates[1],
            ],
          },
        })),
    };

    const popupProfile = (event) => {
      const button = event.target?.closest("button.open-profile");
      if (!button) return;
      const indexId = button.getAttribute("data-index");

      const id = parseInt(indexId, 10); // Convert to number

      const index = users.findIndex((user) => user.id === id);

      const user = users[index];
      setUser(user);
      onOpen();

      // const indexId = button.getAttribute("data-index");
      // console.log("index id", indexId);
      // // return;

      // const index = users.findIndex((user) => user.id === indexId);
      // console.log("index.... ", index);

      // const user = users[index];
      // setUser(user);
      // // setUser(users[parseInt()]);
      // onOpen();
    };

    const members = [],
      sources = [];
    let churchMarker;

    // Add the data source for the points
    map.addSource("members", {
      type: "geojson",
      data: geojson,
      cluster: true,
      clusterMaxZoom: 8, // Max zoom to cluster points
      clusterRadius: 200, // Radius of each cluster
    });
    sources.push("members");

    // Add clustered layer
    map.addLayer({
      id: "clusters",
      type: "circle",
      source: "members",
      filter: ["has", "point_count"],
      paint: {
        "circle-color": "#FFF",
        "circle-radius": ["step", ["get", "point_count"], 20, 10, 25, 50, 32],
        "circle-stroke-width": 1,
        "circle-stroke-color": "#E0E5F2",
      },
    });
    sources.push("clusters");

    // Add cluster count layer
    map.addLayer({
      id: "cluster-count",
      type: "symbol",
      source: "members",
      filter: ["has", "point_count"],
      layout: {
        "text-field": "{point_count_abbreviated}",
        "text-font": ["DIN Offc Pro Medium", "Arial Unicode MS Bold"],
        "text-size": 18,
      },
      paint: {
        "text-color": "#2B3674",
        "circle-color": "#FFF",
      },
    });
    sources.push("cluster-count");

    // Unclustered points layer
    map.addLayer({
      id: "unclustered-point",
      type: "circle",
      source: "members",
      filter: ["!", ["has", "point_count"]],
      paint: {
        "circle-color": "#11b4da",
        "circle-radius": 4,
        "circle-stroke-width": 1,
        "circle-stroke-color": "#fff",
      },
    });
    sources.push("unclustered-point");

    const churchLatLng = [church?.lng, church?.lat];

    // Render HTML elements for un-clustered members
    geojson.features.forEach((feature, index) => {
      const coordinates = feature.geometry.coordinates;
      const {
        firstName,
        lastName,
        role,
        address,
        zip,
        city,
        state,
        avatar,
        id,
      } = feature.properties;

      let el;
      if (avatar?.url || avatar?.thumb) {
        el = document.createElement("img");
        el.className =
          "hidden bg-navy-700 w-12 h-12 text-white border-2 border-white rounded-full object-cover";
        el.src = avatar?.url || avatar?.thumb;
      } else {
        el = document.createElement("div");
        const container = document.createElement("div");
        container.className =
          "w-12 h-12 rounded-full m-auto text-center flex items-center bg-brand-500 text-white border-2 border-gray-100 dark:border-gray-800";
        const nameContainer = document.createElement("div");
        nameContainer.className = "flex-1 font-medium uppercase text-sm";
        nameContainer.innerText = `${firstName?.[0] ?? ""}${
          lastName?.[0] ?? ""
        }`;
        container.appendChild(nameContainer);
        el.appendChild(container);
      }

      // custom marker popup html
      const memberPopupHTML = `
                <div class="px-5 pt-5 pb-4">
                    <div class="flex flex-row gap-3">
                        ${ReactDOMServer.renderToString(
                          <Avatar user={feature.properties} size="md" />
                        )}
                        <div class="flex-1">
                            <h2 class="font-bold text-navy-800 text-base dark:text-white mb-1">${firstName} ${lastName}</h2>
                            ${ReactDOMServer.renderToString(
                              <StatusLabel status={role} />
                            )}
                        </div>
                    </div>

                    <div class="py-4 border-b border-gray-200 flex flex-row">
                        <h2 class="w-24 text-sm text-gray-700 dark:text-gray-200">Driving time</h2>
                        <div class="text-sm text-navy-800 font-bold driving-time dark:text-white">7 minutes</div>
                    </div>
                    <div class="py-4 flex flex-row">
                        <h2 class="w-24 text-sm text-gray-700 dark:text-gray-200">Location</h2>
                        <div class="text-sm text-navy-800 font-bold dark:text-white">
                            <p>${address}</p>
                            <p>${city}</p>
                            <p>${state} ${zip}</p>
                        </div>
                    </div>

                    <button data-index=${
                      // index + 1
                      id
                    } class="open-profile border border-gray-200 text-gray-700 hover:text-gray-800 hover:border-gray-300 dark:text-white rounded-2xl h-12 w-full outline-none">
                        <svg class="inline-block mr-2" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M5.83301 14.1667L14.1663 5.83337M14.1663 5.83337H5.83301M14.1663 5.83337V14.1667" stroke="currentColor" stroke-width="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                        <span class="inline-block">View more</span>
                    </button>
                </div>`;

      // Create a new marker and add it to the map
      const popup = new mapboxgl.Popup({
        offset: 25,
        closeButton: false,
        maxWidth: 300,
      }).setHTML(memberPopupHTML);

      const showRoutes = (event) => {
        if (!church) return;
        const url = `https://api.mapbox.com/directions/v5/mapbox/driving/${churchLatLng.join(
          ","
        )};${coordinates.join(",")}?geometries=geojson&access_token=${
          mapboxgl.accessToken
        }`;
        const drivingTimeEl = event.target
          .getElement()
          .querySelector(".driving-time");
        drivingTimeEl.innerText = "Calculating...";
        fetch(url).then((response) => {
          response.json().then((data) => {
            const route = data.routes[0].geometry;
            drivingTimeEl.innerText = secondsToString(data.routes[0].duration);
            map.getLayer("route") && map.removeLayer("route");
            map.getSource("route") && map.removeSource("route");
            map.addLayer({
              id: "route",
              type: "line",
              source: {
                type: "geojson",
                data: {
                  type: "Feature",
                  properties: {},
                  geometry: route,
                },
              },
              layout: {
                "line-join": "round",
                "line-cap": "round",
              },
              paint: {
                "line-color": "#6DA38C",
                "line-width": 2,
                "line-dasharray": [2, 2],
              },
            });
            sources.indexOf("route") === -1 && sources.push("route");
          });
        });
      };

      popup.on("open", showRoutes);
      if (mapMode === "duration") {
        // 1. Add source first (if not already added!)
        if (!map.getSource("heatmap")) {
          map.addSource("heatmap", {
            type: "geojson",
            data: geojson, // Make sure you have geojson defined in this scope
          });
          sources.push("heatmap");
        }

        // 2. Now add the heatmap layer
        if (!map.getLayer("heatmap-layer")) {
          map.addLayer({
            id: "heatmap-layer",
            type: "heatmap",
            source: "heatmap",
            maxzoom: 15,
            paint: {
              "heatmap-intensity": [
                "interpolate",
                ["linear"],
                ["zoom"],
                10,
                1,
                15,
                3,
              ],
              "heatmap-radius": 30,
              "heatmap-weight": ["get", "weight"], // Adjust this based on driving time or distance
              "heatmap-color": [
                "interpolate",
                ["linear"],
                ["heatmap-density"],
                0,
                "rgba(0,0,255,0)",
                0.2,
                "rgb(0,0,255)",
                0.4,
                "rgb(0,255,0)",
                0.6,
                "rgb(255,255,0)",
                0.8,
                "rgb(255,0,0)",
              ],
            },
          });
          sources.push("heatmap-layer");
        }
      }

      const marker = new mapboxgl.Marker(el)
        .setLngLat(coordinates)
        .setPopup(popup) // Optional: Add a popup
        .addTo(map);

      members.push(marker);
    });

    // update visibility of markers according clustering
    function updateMarkerVisibility() {
      members.forEach((marker) => {
        const features = map.queryRenderedFeatures(
          map.project(marker.getLngLat()),
          {
            layers: ["unclustered-point"],
          }
        );
        const element = marker.getElement();
        element.style.display = features.length === 0 ? "none" : "block";
      });
    }

    const churchEl = document.createElement("div");

    // add church point
    if (church) {
      map.setZoom(12);
      map.setCenter(churchLatLng);
      updateChurchMarkerSize();
      map.on("zoom", updateChurchMarkerSize);
      const churchPopupHTML = `
                <div class="px-5 pt-5 pb-4">
                    <h2 class="font-bold text-base text-navy-800 dark:text-white">${church.name}</h2>
                    <div class="flex w-full flex-row gap-4 min-w-60 mt-4">
                        <p class="flex-auto text-sm text-gray-700 dark:text-gray-200">Location</p>
                        <div class="flex-1 font-bold text-sm text-navy-800 dark:text-white">
                            <p>${church.address}</p>
                            <p>${church.city}</p>
                            <p>${church.state} ${church.zip}</p>
                        </div>
                    </div>
                </div>`;
      churchEl.className =
        "w-12 h-12 bg-white border border-gray-300 rounded-full text-center content-center";
      churchEl.innerHTML = `<svg class="inline-block" width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 19V14.3C0 13.9 0.108333 13.5375 0.325 13.2125C0.541667 12.8875 0.833333 12.6417 1.2 12.475L4 11.225V9.225C4 8.84167 4.1 8.49583 4.3 8.1875C4.5 7.87917 4.76667 7.63333 5.1 7.45L9 5.5V4H8C7.71667 4 7.47917 3.90417 7.2875 3.7125C7.09583 3.52083 7 3.28333 7 3C7 2.71667 7.09583 2.47917 7.2875 2.2875C7.47917 2.09583 7.71667 2 8 2H9V1C9 0.716667 9.09583 0.479167 9.2875 0.2875C9.47917 0.0958333 9.71667 0 10 0C10.2833 0 10.5208 0.0958333 10.7125 0.2875C10.9042 0.479167 11 0.716667 11 1V2H12C12.2833 2 12.5208 2.09583 12.7125 2.2875C12.9042 2.47917 13 2.71667 13 3C13 3.28333 12.9042 3.52083 12.7125 3.7125C12.5208 3.90417 12.2833 4 12 4H11V5.5L14.9 7.45C15.2333 7.63333 15.5 7.87917 15.7 8.1875C15.9 8.49583 16 8.84167 16 9.225V11.225L18.8 12.475C19.1667 12.6417 19.4583 12.8875 19.675 13.2125C19.8917 13.5375 20 13.9 20 14.3V19C20 19.55 19.8042 20.0208 19.4125 20.4125C19.0208 20.8042 18.55 21 18 21H13C12.7167 21 12.4792 20.9042 12.2875 20.7125C12.0958 20.5208 12 20.2833 12 20V18C12 17.45 11.8042 16.9792 11.4125 16.5875C11.0208 16.1958 10.55 16 10 16C9.45 16 8.97917 16.1958 8.5875 16.5875C8.19583 16.9792 8 17.45 8 18V20C8 20.2833 7.90417 20.5208 7.7125 20.7125C7.52083 20.9042 7.28333 21 7 21H2C1.45 21 0.979167 20.8042 0.5875 20.4125C0.195833 20.0208 0 19.55 0 19ZM10 12.5C10.4167 12.5 10.7708 12.3542 11.0625 12.0625C11.3542 11.7708 11.5 11.4167 11.5 11C11.5 10.5833 11.3542 10.2292 11.0625 9.9375C10.7708 9.64583 10.4167 9.5 10 9.5C9.58333 9.5 9.22917 9.64583 8.9375 9.9375C8.64583 10.2292 8.5 10.5833 8.5 11C8.5 11.4167 8.64583 11.7708 8.9375 12.0625C9.22917 12.3542 9.58333 12.5 10 12.5Z" fill="#2B3674"/></svg>`;
      // Create a new marker and add it to the map

      const popup = new mapboxgl.Popup({
        offset: 25,
        closeButton: false,
        maxWidth: 300,
      }).setHTML(churchPopupHTML);
      churchMarker = new mapboxgl.Marker(churchEl)
        .setLngLat(churchLatLng)
        .setPopup(popup)
        .addTo(map);
    }

    campusMarkersRef.current.forEach((marker) => marker.remove());
    campusMarkersRef.current = [];

    // add campuses
    campuses?.forEach((campus) => {
      const campusLatLng = [
        campus?.location?.coordinates?.[0],
        campus?.location?.coordinates?.[1],
      ];

      const popupHTML = `
    <div class="px-5 pt-5 pb-4">
      <h2 class="font-bold text-base text-navy-800 dark:text-white">${campus?.name}</h2>
      <div class="flex w-full flex-row gap-4 min-w-60 mt-4">
        <p class="flex-auto text-sm text-gray-700 dark:text-gray-200">Location</p>
        <div class="flex-1 font-bold text-sm text-navy-800 dark:text-white">
          <p>${campus?.address}</p>
          <p>${campus?.city}</p>
          <p>${campus?.state} ${campus?.zipCode}</p>
        </div>
      </div>
    </div>
  `;

      const campusEl = document.createElement("div");
      campusEl.className =
        "w-12 h-12 bg-white border border-gray-300 rounded-full text-center content-center";
      campusEl.innerHTML = `<svg class="inline-block" width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 19V14.3C0 13.9 0.108333 13.5375 0.325 13.2125C0.541667 12.8875 0.833333 12.6417 1.2 12.475L4 11.225V9.225C4 8.84167 4.1 8.49583 4.3 8.1875C4.5 7.87917 4.76667 7.63333 5.1 7.45L9 5.5V4H8C7.71667 4 7.47917 3.90417 7.2875 3.7125C7.09583 3.52083 7 3.28333 7 3C7 2.71667 7.09583 2.47917 7.2875 2.2875C7.47917 2.09583 7.71667 2 8 2H9V1C9 0.716667 9.09583 0.479167 9.2875 0.2875C9.47917 0.0958333 9.71667 0 10 0C10.2833 0 10.5208 0.0958333 10.7125 0.2875C10.9042 0.479167 11 0.716667 11 1V2H12C12.2833 2 12.5208 2.09583 12.7125 2.2875C12.9042 2.47917 13 2.71667 13 3C13 3.28333 12.9042 3.52083 12.7125 3.7125C12.5208 3.90417 12.2833 4 12 4H11V5.5L14.9 7.45C15.2333 7.63333 15.5 7.87917 15.7 8.1875C15.9 8.49583 16 8.84167 16 9.225V11.225L18.8 12.475C19.1667 12.6417 19.4583 12.8875 19.675 13.2125C19.8917 13.5375 20 13.9 20 14.3V19C20 19.55 19.8042 20.0208 19.4125 20.4125C19.0208 20.8042 18.55 21 18 21H13C12.7167 21 12.4792 20.9042 12.2875 20.7125C12.0958 20.5208 12 20.2833 12 20V18C12 17.45 11.8042 16.9792 11.4125 16.5875C11.0208 16.1958 10.55 16 10 16C9.45 16 8.97917 16.1958 8.5875 16.5875C8.19583 16.9792 8 17.45 8 18V20C8 20.2833 7.90417 20.5208 7.7125 20.7125C7.52083 20.9042 7.28333 21 7 21H2C1.45 21 0.979167 20.8042 0.5875 20.4125C0.195833 20.0208 0 19.55 0 19ZM10 12.5C10.4167 12.5 10.7708 12.3542 11.0625 12.0625C11.3542 11.7708 11.5 11.4167 11.5 11C11.5 10.5833 11.3542 10.2292 11.0625 9.9375C10.7708 9.64583 10.4167 9.5 10 9.5C9.58333 9.5 9.22917 9.64583 8.9375 9.9375C8.64583 10.2292 8.5 10.5833 8.5 11C8.5 11.4167 8.64583 11.7708 8.9375 12.0625C9.22917 12.3542 9.58333 12.5 10 12.5Z" fill="#d2ad27ff"/></svg>`;

      const popup = new mapboxgl.Popup({
        offset: 25,
        closeButton: false,
        maxWidth: 300,
      }).setHTML(popupHTML);

      // new mapboxgl.Marker(campusEl)
      //   .setLngLat(campusLatLng)
      //   .setPopup(popup)
      //   .addTo(map);

      const marker = new mapboxgl.Marker(campusEl)
        .setLngLat(campusLatLng)
        .setPopup(popup)
        .addTo(map);

      campusMarkersRef.current.push(marker);
    });

    // 2. Function to update marker size
    function updateChurchMarkerSize() {
      if (!churchMarker) return;
      const zoom = map.getZoom();
      const size = getChurchMarkerSize(zoom);
      churchEl.style.width = `${size}px`;
      churchEl.style.height = `${size}px`;
      // Optionally adjust inner SVG size as well
      const svg = churchEl.querySelector("svg");
      if (svg) {
        svg.style.width = `${Math.round(size * 0.6)}px`;
        svg.style.height = `${Math.round(size * 0.6)}px`;
      }
    }

    // 1. Function to get marker size based on zoom
    function getChurchMarkerSize(zoom) {
      // Tweak these values as needed
      const minSize = 20; // px
      const maxSize = 48; // px (original size)
      const minZoom = 5;
      const maxZoom = 18;
      // Linear interpolation between min and max
      if (zoom <= minZoom) return minSize;
      if (zoom >= maxZoom) return maxSize;
      return (
        minSize + ((zoom - minZoom) / (maxZoom - minZoom)) * (maxSize - minSize)
      );
    }

    map.on("move", updateMarkerVisibility);
    map.on("zoom", updateMarkerVisibility);
    map.on("render", updateMarkerVisibility);

    updateMarkerVisibility();

    map.getContainer().addEventListener("click", popupProfile);

    return () => {
      map.getContainer().removeEventListener("click", popupProfile);
      if (!map.getCanvasContainer()) return; // removed by map creator hook already
      sources.forEach((id) => map.getLayer(id) && map.removeLayer(id));
      sources.forEach((id) => map.getSource(id) && map.removeSource(id));
      members.forEach((m) => m.remove());
      map.off("zoom", updateChurchMarkerSize);
      churchMarker?.remove();
      map.off("move");
      map.off("zoom");
      map.off("render");
    };
  }, [church, map, mapMode, onOpen, users, campuses]);

  // This effect triggers only AFTER debounce delay
  // useEffect(() => {
  //   if (!debouncedSearchQuery || !map || users.length === 0) return;

  //   const foundUser = users.find((user) =>
  //     `${user.firstName} ${user.lastName}`
  //       .toLowerCase()
  //       .includes(debouncedSearchQuery.toLowerCase())
  //   );

  //   if (foundUser) {
  //     const lngLat = [
  //       foundUser?.location?.coordinates[0],
  //       foundUser?.location?.coordinates[1],
  //     ];

  //     map.flyTo({
  //       center: lngLat,
  //       zoom: 14,
  //       essential: true,
  //     });

  //     const featureIndex = users.findIndex((u) => u.id === foundUser.id);
  //     const markerEl = document.querySelector(
  //       `button.open-profile[data-index='${featureIndex}']`
  //     );
  //     if (markerEl) {
  //       markerEl.click(); // Trigger popup manually
  //     }
  //   }
  // }, [debouncedSearchQuery]);

  return (
    <>
      <div className="flex-1 mt-3 gap-2 rounded-[20px] md:px-3 2xl:px-4 4xl:px-6 flex flex-col">
        {loading && (
          <div className="fixed inset-0 bg-white/50 flex justify-center items-center z-50 w-full ml-[10%]">
            <Loader />
          </div>
        )}
        {/* Filter pane */}
        <div className="flex flex-col lg:flex-row flex-wrap lg:flex-nowrap gap-3">
          <div className="select-none flex-1 flex">
            <div className="flex w-full h-12 lg:max-w-80 items-center rounded-2xl bg-lightPrimary text-navy-700 dark:bg-navy-900 dark:text-white">
              <p className="pl-3 pr-2 text-xl">
                <FiSearch className="h-4 w-4 text-gray-400 dark:text-white" />
              </p>
              <input
                className="block h-full w-full rounded-full bg-lightPrimary text-sm font-medium text-navy-700 outline-none placeholder:!text-gray-400 dark:bg-navy-900 dark:text-white dark:placeholder:!text-gray-700"
                placeholder="Search by name"
                value={queryOptions.search}
                onChange={(e) =>
                  setQueryOptions({ ...queryOptions, search: e.target.value })
                }
              />
            </div>
          </div>
          <div className="flex flex-wrap lg:flex-nowrap gap-3 content-center">
            <div className="w-[210px]">
              <Select
                value={mapMode}
                onChange={(e) => setMapMode(e.target.value)}
                required
              >
                <option value="normal">Map view</option>
                <option value="duration">Driving time heatmap</option>
                {/* <option value="donations">Donations heatmap</option>
                <option value="engagements">Engagements heatmap</option> */}
              </Select>
            </div>

            <div className="w-[210px]">
              <Select
                value={campusFilter}
                onChange={(e) => setCampusFilter(e.target.value)}
                required
              >
                <option value="all">Select the Campus</option>
                {campusId?.length > 0 ? (
                  campusId?.map((c) => (
                    <option key={c?.id} value={c?.id}>
                      {c?.name}
                    </option>
                  ))
                ) : (
                  <option>No campus found</option>
                )}
              </Select>
            </div>

            {/* <div className="w-[120px]">
              <Select
                value={queryOptions.role}
                onChange={(e) => {
                  setQueryOptions({ ...queryOptions, role: e.target.value });
                }}
                required
              >
                <option value="">All Roles</option>
                <option value="admin">Admin</option>
                <option value="staff">Staff</option>
                <option value="member">Member</option>
                <option value="volunteer">Volunteer</option>
              </Select>
            </div> */}

            <div className="w-[165px]">
              <Select
                value={queryOptions.driveTimeRange || ""}
                placeholder="Driving distance"
                onChange={(e) =>
                  setQueryOptions({
                    ...queryOptions,
                    driveTimeRange: e.target.value,
                  })
                }
                required
              >
                <option value="-1">All</option>
                <option value="0-5">0-5 minutes</option>
                <option value="6-10">6-10 minutes</option>
                <option value="11-20">11-20 minutes</option>
                <option value="21-30">21-30 minutes</option>
                <option value="31-45">31-45 minutes</option>
                <option value="46-60">46-60 minutes</option>
                <option value="61">61+ minutes</option>
              </Select>
            </div>

            {/* <div className="w-[150px]">
              <Select
                value={queryOptions.group}
                onChange={(e) => {
                  setQueryOptions({ ...queryOptions, group: e.target.value });
                }}
                required
              >
                <option value="">All Groups</option>
              </Select>
            </div> */}
          </div>
        </div>

        <Drawer isOpen={isOpen} onClose={onClose}>
          <ModalOverlay
            bg={darkmode ? "#A3AED080" : "#2B367480"}
            backdropFilter="blur(3px)"
            zIndex={15}
            onClick={() => onClose()}
          />
          <DrawerContent
            containerProps={{ zIndex: 20 }}
            className="my-2 ml-0 mr-4 w-[calc(100vw_-_32px)] max-w-[calc(100vw_-_32px)] rounded-2xl bg-white shadow-[-20px_17px_40px_4px_rgba(112,_144,_176,_0.18)] dark:bg-background-900 dark:shadow-[-22px_32px_51px_4px_#0B1437] sm:ml-4 md:w-[600px] md:max-w-[600px]"
          >
            <DrawerCloseButton className="absolute right-4 top-4 text-xs p-3 text-gray-900 dark:text-white" />

            {readonlyForm ? (
              <UserDetails
                user={user}
                setUser={setUser}
                onClose={onClose}
                setReadonly={setReadonlyForm}
              />
            ) : (
              <EditUser
                user={user}
                setUser={setUser}
                onClose={onClose}
                onCancel={() => setReadonlyForm(true)}
              />
            )}
          </DrawerContent>
        </Drawer>

        {/* Map */}
        <div id="map" className="min-h-[300px] flex-1" />
      </div>
    </>
  );
};

export default MemberLocation;
